module.exports = __webpack_public_path__ + "73bac18d830947c08f14566bdcfa49ac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/food/food4.png
// module id = 2456
// module chunks = 0